export default __webpack_public_path__ + "static/media/Thumb_Accessories_00.088a7318.png";